import { render, staticRenderFns } from "./AffiliateTable.html?vue&type=template&id=0bbabc58&scoped=true&"
import script from "./AffiliateTable.js?vue&type=script&lang=js&"
export * from "./AffiliateTable.js?vue&type=script&lang=js&"
import style0 from "./affiliate-table.scss?vue&type=style&index=0&id=0bbabc58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbabc58",
  null
  
)

export default component.exports